import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { KEYS } from "../constants/keys";

@Injectable({
    providedIn:'root'
})
export class storageService {

    companyChanged$ = new Subject<string>();

    public getClientId(){
        return localStorage.getItem(KEYS.CLIENT_ID);
    }
    
    getCompanyId(){
        return localStorage.getItem(KEYS.COMPANY_ID);
    }

    getBranchId(){
        return localStorage.getItem(KEYS.BRANCH_ID);
    }

    setClientId(clientId:any){
        localStorage.setItem('CLIENT_ID',clientId);
    }

    setCompanyId(companyId:any){
        localStorage.setItem('COMPANY_ID',companyId);
        this.companyChanged$.next(companyId);
    }

    setBranchId(branchId:any){
        localStorage.setItem('BRANCH_ID',branchId);
    }
   
}